import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class ContractGroup<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: index */
  index?: number;
  /** Alias: level */
  level?: number;
  /** Alias: name */
  name?: any;

  __typename?: string;
}

const fields: FieldDefinitions<ContractGroup> = {
  code: {
    alias: 'code',
  },
  index: {
    alias: 'index',
  },
  level: {
    alias: 'level',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const contractGroupEntityDefinition: EntitiyDefinition<ContractGroup> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'ContractGroup',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
